import React, { ForwardedRef } from "react";
import ReactDatePicker, { ReactDatePickerProps } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAuthenticated, useWeekStartsOn } from "@gettactic/hooks";
import { cva } from "class-variance-authority";
import { inputV2Classes } from "@/features/reserve/components/utils/classes";
import { useI18n } from "@/lib/hooks/useI18n";

const datePickerVariants = cva(
  "mt-1 block w-full rounded-md border-neutral-300 px-4 py-3 font-bold text-secondary-foreground text-sm placeholder-blue-800 focus:border-primary focus:outline-none focus:ring-primary",
  {
    variants: {
      variant: {
        default: "",
        v2: inputV2Classes
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);

export const DatePicker = React.forwardRef(
  (
    props: ReactDatePickerProps & { variant?: "default" | "v2" },
    ref: ForwardedRef<ReactDatePicker>
  ) => {
    const {
      userContext: { authenticatedUser }
    } = useAuthenticated();
    const { templates } = useI18n(authenticatedUser);
    const weekStartsOn = useWeekStartsOn();
    const dateFormat = props.dateFormat ?? templates.displayDate;
    return (
      <ReactDatePicker
        ref={ref}
        dateFormat={dateFormat}
        calendarStartDay={weekStartsOn}
        className={datePickerVariants({
          variant: props.variant,
          className: props.className
        })}
        {...props}
        formatWeekDay={(nameOfDay) => nameOfDay.substring(0, 1)}
        portalId={props.portalId !== undefined ? props.portalId : "root-portal"}
      />
    );
  }
);
